import React from 'react';
interface SectionHeadingProps {
  id?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  children?: React.ReactNode;
}
export function SectionHeading({
  id,
  title,
  intro,
  align = 'left',
  tone = 'dark',
  children
}: SectionHeadingProps) {
  const center = align === 'center';
  const light = tone === 'light';
  return <div className={center ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-414" data-mp="3606vjoswils9">
      <h2 id={id} className={`text-3xl font-bold leading-tight sm:text-4xl ${light ? 'text-white' : 'text-ink'}`} data-id="element-415" data-mp="3b1e3bnv1nkyx">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-lg leading-relaxed ${light ? 'text-white/85' : 'text-ink-soft'}`} data-id="element-416" data-mp="3jtg27hpgst73">{intro}</p>}
      {children}
    </div>;
}